module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_about_dm-0fd71509fbb22a27ac4e79da8c824f14.png";